import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { DispatchFunction, ILogs, IActiveFilter } from '@app/models';
import { GET_ALL_LOGS, GET_ALL_LOGS_LOADING } from '@app/store/constants';
import { logsService } from '@app/services';

export function handleGetLogsData(top: number, token: string, filters?: IActiveFilter[]): DispatchFunction {
    return ((dispatch: Dispatch) => {
        dispatch(getAllLogsLoading(true));
        logsService.getLogs(top, token, filters)
            .then((response: AxiosResponse) => {
                dispatch(getAllLogs(response.data));
                dispatch(getAllLogsLoading(false));
            });
    });
}

export function getAllLogs(logs: ILogs[]) {
    return {
        payload: logs,
        type: GET_ALL_LOGS
    };
}

export function getAllLogsLoading(loading: boolean) {
    return {
        payload: loading,
        type: GET_ALL_LOGS_LOADING
    };
}